import styled from 'styled-components';

import {IconButton} from 'components/ui-kit/IconButton';
import {
    TableView as TableView20,
    Root as Root20,
    CellContainer as CellContainer20,
    HeaderCell as HeaderCell20,
    Footer as Footer20,
    ExpandedRow as ExpandedRow20,
    ExpandedCell as ExpandedCell20,
    ExpandedCellWrapper as ExpandedCellWrapper20,
    ExpandToggle as ExpandToggle20,
} from 'components/ui-kit/Table2.0/Table/styled';
import {border, buttonReset, colors, font, icons} from 'theme';

export const ExpandedRow = ExpandedRow20;
export const ExpandedCell = ExpandedCell20;
export const ExpandedCellWrapper = ExpandedCellWrapper20;
export const ExpandToggle = styled(ExpandToggle20)<{paddingLeft?: string}>`
    margin-bottom: 6px;
    padding-left: ${(p) => p.paddingLeft ?? '0'};
`;

export const DefaultCell = styled.div<{
    noPadding: string;
    fullUneditableFields: string[];
    id: string;
    allowEditing: boolean;
}>`
    width: 100%;
    height: auto;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: ${(p) => p.noPadding};
    ${(p) => p.id === 'codeGtin' && 'min-width: 0;'}
    cursor: ${(p) =>
        p.fullUneditableFields.includes(p.id) || !p.allowEditing ? 'default' : 'pointer'};
`;

export const Root = styled(Root20)``;

export const RowDiv = styled.div`
    &.tr.can-expand:hover {
        background-color: #f8f8ff;
    }
    &.tr.has-modal:hover {
        background-color: #f8f8ff;
        cursor: pointer;
        & ${DefaultCell} {
            cursor: pointer;
        }
    }
    &.tr.has-errors {
        background-color: #fff2f2;
    }
`;

export const TableView = styled(TableView20)`
    width: 100%;
    overflow-x: visible;

    .td.codeGtin {
        min-width: 0;
    }
`;

export const CellContainer = styled(CellContainer20)``;

export const HeaderCell = styled(HeaderCell20)``;

export const Footer = styled(Footer20)``;

export const PaginationContainer = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const PageInfo = styled.span`
    font-size: 12px;
    color: ${colors.textMuted};
`;

export const PaginationControls = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const PaginationButton = styled.button`
    ${buttonReset};
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    background-color: ${colors.transparent};
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    &:not(:disabled):hover {
        background-color: ${colors.background};
    }
`;

export const PageSizeSelect = styled.select`
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    background-color: ${colors.white};
    cursor: pointer;
    margin-left: 10px;
`;
export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;
`;
export const RowText = styled.div<{padding?: string; gap?: string}>`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    color: ${colors.black};
    padding: ${(p) => p.padding ?? '0 16px'};
    border-radius: ${border.radius};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    gap: ${(p) => p.gap ?? '0'};

    > span {
        flex: 1;
    }
`;

export const CodeText = styled.span`
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-all;
    white-space: normal;
`;

export const RowTextEllipsis = styled.div`
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 30ch;
`;

export const TextWrapperRow = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    gap: 8px;
    padding: 8px 0;
`;

export const TextWrapperItem = styled.div<{withSeparator?: boolean}>`
    display: inline-flex;
    align-items: center;
    justify-content: stretch;
    gap: 8px;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.darkGrey};
    ${(p) =>
        p.withSeparator &&
        `
            &:before {
                content: '';
                width: 1px;
                height: 18px;
                background: ${colors.textMuted};
            }
        `}
`;

export const GroupByGtinButtonRoot = styled.button`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 8px;
    padding: 0 16px;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
`;

export const GroupByGtinInModalRoot = styled(GroupByGtinButtonRoot)`
    position: relative;
`;

export const ViewCodesDropdown = styled.div`
    z-index: 1;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    height: fit-content;
    max-height: 370px;
    transform: translateY(calc(100% + 8px));
    overflow: hidden;

    background-color: ${colors.white};
    box-shadow: 0px 12px 32px 0px #34343429;
    border-radius: 16px;
`;

export const ViewCodesDropdownList = styled.ul`
    box-sizing: border-box;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    height: 100%;
    margin: 0;
    list-style: none;
    align-items: flex-start;
    overflow-x: auto;
    cursor: default;
`;

export const CopyButton = styled(IconButton)`
    margin-left: 5px;
    padding: 10px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
`;

export const ViewCodesDropdownListItem = styled.li`
    width: 100%;
    height: 38px;
    min-height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textGrey1};
    &:hover {
        ${CopyButton} {
            opacity: 1;
        }
    }
`;

export const MarkedTag = styled.span`
    position: absolute;
    top: -10px;
    left: 15px;
    display: inline-flex;
    width: 100%;
    color: ${colors.textSecondary};
    font-size: 11px;
    font-weight: 400;
`;
